/**
 * CykelmakkerApi
 * CykelmakkerApi
 *
 * The version of the OpenAPI document: v3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EExportExcelReportBy = 'FinishedDate' | 'CreatedDate';

export const EExportExcelReportBy = {
    FinishedDate: 'FinishedDate' as EExportExcelReportBy,
    CreatedDate: 'CreatedDate' as EExportExcelReportBy
};

